module.exports = __webpack_public_path__ + "img/icon_ball68.ab981893.png";